import { PayloadAction } from '@reduxjs/toolkit';
import { CategoryState } from '../types';

const resetToSingleCategoryReducer = (
  state: CategoryState,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  action: PayloadAction<number | undefined>,
) => {
  state.activeCategories = action.payload ? [action.payload] : [];
};

export default resetToSingleCategoryReducer;
